export const ACTIONS = {
  JOIN: "JOIN",
  LEAVE: "LEAVE",
  JOINED: "JOINED",
  USER_LEFT: "USER_LEFT",
  CODE_CHANGE: "CODE_CHANGE",
  SYNC_CODE: "SYNC_CODE",
  LANGUAGE_CHANGE: "LANGUAGE_CHANGE",
  SYNC_LANGUAGE: "SYNC_LANGUAGE",
};
